<ng-template elderToolbarColumn="right.actions">
  <app-facility-context-menu></app-facility-context-menu>
</ng-template>

<elder-basic-pane-layout class="full">
  <elder-pane>
    <app-work-order-browser
      class="flex"
      #orderBrowser
      appFacilityContext
      (facilityChange)="orderBrowser.facility = $event"
    >
    </app-work-order-browser>
  </elder-pane>
</elder-basic-pane-layout>
